import axios from 'axios';
import constants from "../constants";

let calculatePriceDistance = async (distance, typeService) => {

  const calculatePriceValueUrl =
      constants().URL_SERVICE +
      `setting/distancerate/calculate_price/?distance=${distance}&service_type=${typeService}`;

    const calculatePriceConfig = {
      headers: {
        Authorization: "Token " + localStorage.token,
      },
    };
    
  let result = await axios.get(calculatePriceValueUrl, calculatePriceConfig);
  return result.data;
};

export { calculatePriceDistance };



// WEBPACK FOOTER //
// ./src/services/agent.js